import { isAbortOrCanceledError } from "@captions-web/utils/abort-signals";
import { datadogRum } from "@datadog/browser-rum";

const APPLICATION_ID = "07a12419-e6d3-41e3-9290-2efd27ef393c";
const CLIENT_TOKEN = "pub5a66cd4b7454f787a1a309a30807b6a0";

const ENV = import.meta.env.VITE_APP_ENV as "dev" | "test" | "preview" | "prod";
export const IS_DATADOG_ENABLED = ENV === "prod" || ENV === "preview";

const COMMON_ANNOYING_BENIGN_ERRORS = ["ResizeObserver loop limit exceeded", "AbortError"];

// helper function to filter out known handled errors
function shouldIgnoreError(error: any) {
  if (typeof error === "string" && COMMON_ANNOYING_BENIGN_ERRORS.includes(error)) {
    return true;
  }
  if (error && error.message && COMMON_ANNOYING_BENIGN_ERRORS.includes(error.message)) {
    return true;
  }
  if (isAbortOrCanceledError(error)) {
    return true;
  }
  return false;
}

export const addDatadogAction = (name: string, properties?: Record<string, any>) => {
  if (!IS_DATADOG_ENABLED) {
    return;
  }
  datadogRum.addAction(name, properties);
};

export const addDataDogError = (error: unknown, ctx: Record<string, any>) => {
  if (!IS_DATADOG_ENABLED) {
    return;
  }
  if (shouldIgnoreError(error)) {
    return;
  }
  datadogRum.addError(error, ctx);
};

export const setDatadogUser = (user: {
  id: string;
  email?: string;
  orgId?: string;
  role?: "admin" | "member";
}) => {
  if (IS_DATADOG_ENABLED) {
    datadogRum.setUser({
      id: user.id,
      email: user.email,
      orgId: user.orgId,
      role: user.role,
    });
  }
};

export const initDatadog = () => {
  if (IS_DATADOG_ENABLED) {
    datadogRum.init({
      applicationId: APPLICATION_ID,
      clientToken: CLIENT_TOKEN,
      site: "us5.datadoghq.com",
      service: "mirage-studio-web",
      env: import.meta.env.VITE_APP_ENV as "dev" | "test" | "preview" | "prod",
      version: import.meta.env.VITE_CF_PAGES_COMMIT_SHA || "1.0.0",
      sessionSampleRate: 100,
      sessionReplaySampleRate: 10,
      defaultPrivacyLevel: "mask-user-input",
    });

    window.addEventListener("error", (event) => {
      addDataDogError(event.error || new Error(event.message), {
        source: event.filename,
        line: event.lineno,
        column: event.colno,
      });
    });

    window.addEventListener("unhandledrejection", (event) => {
      addDataDogError(event.reason, {
        unhandledRejection: true,
      });
    });

    console.log("Datadog RUM initialized");
  }
};
